export default function Footer() {
    return (
        <footer className="bg-weave-ink text-weave-cream" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid md:grid-cols-3 gap-10">
                <div>
                    <img
                        src="/weave-logo.png"
                        alt="The Weave"
                        className="h-12 w-auto mb-4"
                    />
                    <p className="text-sm text-weave-cream/70 max-w-xs leading-relaxed">
                        A credit-score-style check for your funding readiness and likely funding route.
                    </p>
                </div>
                <div>
                    <div className="text-overline text-weave-yellow mb-3">Explore</div>
                    <ul className="space-y-2 text-sm text-weave-cream/85">
                        <li><a href="/check" className="hover:text-weave-yellow">Take the score</a></li>
                        <li><a href="/#how-it-works" className="hover:text-weave-yellow">How it works</a></li>
                        <li><a href="/#membership" className="hover:text-weave-yellow">Membership</a></li>
                        <li><a href="https://tidycal.com/the-weave/funding-clinic" target="_blank" rel="noopener noreferrer" className="hover:text-weave-yellow">Book a funding clinic</a></li>
                    </ul>
                </div>
                <div>
                    <div className="text-overline text-weave-yellow mb-3">Fine print</div>
                    <p className="text-xs text-weave-cream/60 leading-relaxed">
                        The Funding Readiness Score is directional guidance only — not a regulated
                        assessment, investment advice, or a credit score. By using this tool, you
                        agree your inputs may be used to generate your results and, with
                        membership, matched against live funding opportunities.
                    </p>
                </div>
            </div>
            <div className="border-t border-weave-cream/10 py-5">
                <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-wrap justify-between gap-2 text-xs text-weave-cream/60">
                    <span>© {new Date().getFullYear()} The Weave — The 1% Club</span>
                    <span>Built with care in the UK</span>
                </div>
            </div>
        </footer>
    );
}
